import { OrientationIcon } from 'components/ProductSidebar/ProductCard/ProductCardSVGs';
import { ProductCardIcon } from '../../@types';

interface Product {
  coreProductId: string;
}

export const getProductCardIconWithTooltip = (product: Product): ProductCardIcon => {
  const icon = product.coreProductId.includes('--') ? OrientationIcon : '';
  const tooltip = icon ? 'storageone.canBeRotatedDesignArea' : undefined;

  return { icon, tooltip };
};
